import React, { useEffect } from 'react';
import {
  DifferentiationListItemFooterButton,
  DifferentiationListItemFooterButtonsWrapper,
  DifferentiationListItemFooterDeleteButton,
  DifferentiationListItemFooterWrapper,
  FooterSwitchWrapper,
} from './Atoms';
import { ITrajectoryDifferentiation } from 'src/config/api/models/Trajectory';
import { Icons, ListItemSwitchActionButton } from 'src/modules/shared/components';
import { useTranslation } from 'react-i18next';
import { DifferentiationScreenAction } from '../DifferentiationScreenAction';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import theme from 'src/config/theme';
import { useFetch } from 'src/modules/shared';
import apiRoutesV2 from 'src/config/api/routes';

type Props = {
  version?: ITrajectoryDifferentiation;
  openCallback: (screen: DifferentiationScreenAction, meta?: any) => void;
  openTrajectoryVisible: boolean;
  refetchTrajectory: (trajectoryId: ITrajectoryDifferentiation['id']) => void;
  isCurrentVersion: boolean;
};

export const DifferentiationListItemFooter: React.FC<Props> = ({
  version,
  openCallback,
  openTrajectoryVisible,
  refetchTrajectory,
  isCurrentVersion,
}) => {
  const { t } = useTranslation();
  const isChecked = !!version?.isCollab;

  /* to do: messages when collab 200 / error */
  const [postIsCollabResponse, postIsCollab] = useFetch(
    apiRoutesV2.toggleTrajectoryCollab(version?.id as string),
    {
      method: 'PATCH',
    }
  );

  useEffect(() => {
    if (postIsCollabResponse.error) {
      console.log('error', postIsCollabResponse.error);
    }
  }, [postIsCollabResponse]);

  return (
    <DifferentiationListItemFooterWrapper>
      <>
        <FooterSwitchWrapper
          className={version?.isDefaultVersion || !version?.isOwner ? 'is-hidden' : ''}
        >
          <ListItemSwitchActionButton
            icon={Icons.COLLABORATION}
            checked={isChecked}
            onChange={() => postIsCollab()}
            tooltip={t('differentiations.isCollabTooltip')}
          />
          <span>SAMENWERKEN</span>
        </FooterSwitchWrapper>
        <DifferentiationListItemFooterButtonsWrapper>
          <DifferentiationListItemFooterButton
            className={openTrajectoryVisible && !isCurrentVersion ? '' : 'hide-button'}
            onClick={() => refetchTrajectory(version?.id ? version.id : '')}
          >
            OPEN
          </DifferentiationListItemFooterButton>
          {version?.isOwner && (
            <DifferentiationListItemFooterDeleteButton
              className={!version?.isDefaultVersion && isCurrentVersion ? '' : 'hide-button'}
              onClick={() => openCallback(DifferentiationScreenAction.DELETE, { version })}
            >
              <FontAwesomeSpriteIcon
                iconSize="xs"
                icon={SpriteIconsLight.TRASH}
                color={theme.palette.secondary.main}
              />
            </DifferentiationListItemFooterDeleteButton>
          )}
        </DifferentiationListItemFooterButtonsWrapper>
      </>
    </DifferentiationListItemFooterWrapper>
  );
};
